export default "__VITE_ASSET__1Q_wY$Vm__";